import React from 'react';
import { Box } from 'rebass';
import { SidebarEntry, isSection } from './navConfig';
import SidebarSection from './SidebarSection';
import SidebarLink from './SidebarLink';
import Icon from '../Icon/Icon';

type Props = {
  entries: SidebarEntry[];
  mode: string;
  collapsed: boolean;
};

const SidebarNav = ({ entries, mode, collapsed }: Props): JSX.Element => {
  return (
    <Box as="nav" py={2}>
      {entries.map((entry, i) => {
        if (isSection(entry)) {
          return (
            <SidebarSection
              key={i}
              section={entry}
              mode={mode}
              collapsed={collapsed}
            />
          );
        }
        return (
          <SidebarLink
            key={i}
            exact={!entry.href}
            to={`/${mode}${entry.href}`}
            collapsed={collapsed}
            isSection
          >
            {entry.icon && (
              <Icon icon={entry.icon} size={16} style={{ flexShrink: 0 }} />
            )}
            {!collapsed && entry.text}
          </SidebarLink>
        );
      })}
    </Box>
  );
};

export default SidebarNav;
